'use strict';

const PATTERN_SELECTOR = '.shorly-top-section__pattern';
const VIEWBOX_CENTER = 750;
const OFFSET = 600;
const STAGGER_MS = 70;
const SVG_NS = 'http://www.w3.org/2000/svg';

const pattern = document.querySelector(PATTERN_SELECTOR);

if (pattern && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
	const svg = pattern.querySelector('svg');
	const rects = svg ? [...svg.querySelectorAll('rect')] : [];

	rects.forEach((rect, index) => {
		const group = document.createElementNS(SVG_NS, 'g');
		rect.parentNode.insertBefore(group, rect);
		group.appendChild(rect);

		const x = parseFloat(rect.getAttribute('x') || '0');
		const width = parseFloat(rect.getAttribute('width') || '0');
		const centerX = x + width / 2;
		const offset = centerX < VIEWBOX_CENTER ? -OFFSET : OFFSET;

		group.style.setProperty('--pattern-offset', `${offset}px`);
		group.style.setProperty('--pattern-delay', `${index * STAGGER_MS}ms`);
	});

	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			pattern.classList.add('is-animated');
		});
	});
}
